/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {useSafeState} from "../../../Hooks/useSafeState";
import {GuidUtils} from "../../../Utils";

import {FunderFieldEditor} from "../ServiceDrivenEditors";
import {useDebouncedIsValidNewOption} from "../../../Hooks/useDebouncedIsValidNewOption";


export const ProjectFunderFieldEditor = (props) => {
	const { 
		CustomData = {},
		...remainingProps 
	} = props;
	const {
		filter = null,
		OnUpdateModel,
		onValidateItem = (inputValue) => true,
	} = CustomData;
	
	const [inputValue, setInputValue] = useSafeState('');
	
	const onUpdateModel = (funder) => {
		// if we already have this ProjectFunder, update the existing
		// one, so we retain the historical primary key
		const existingProjectFunder = props?.Data ?? {};
		
		const projectFunder = {
			...existingProjectFunder,
			// NOTE: 0 is used for _tempId models so that 
			// RequiredValidator treats them as valid (see 1f076dc1)
			funderId: funder.funderId ?? (funder._tempId ? '0' : null),
			Funder: funder,
		};
		OnUpdateModel(projectFunder);
	}
	
	const [isValidNewOption, isLoading] = useDebouncedIsValidNewOption(
		onValidateItem,
		inputValue,
		500
	)
	
	return <FunderFieldEditor
		// context={{organizationId}}
		{...remainingProps}
		
		filter={filter}
		
		OnUpdate={() => {}}
		OnUpdateModel={onUpdateModel}
		
		onInputChange={setInputValue}
		isLoading={isLoading}
		isValidNewOption={isValidNewOption}
		getNewOptionData={(inputValue, label) =>
			({
				name: inputValue,
				_tempId: GuidUtils.Generate(),
				label: label
			})
		}
	/>
	
}

